import { debug } from "console";
import { Component, ChangeDetectionStrategy, OnInit, Input, ChangeDetectorRef } from "@angular/core";
import { FunctionPublic } from "../../nfc/dung-chung/__function/common_function";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_material from "@amcharts/amcharts4/themes/material";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { Inject, NgZone, PLATFORM_ID } from "@angular/core";
import { isPlatformBrowser } from "@angular/common";

am4core.useTheme(am4themes_material);
am4core.useTheme(am4themes_animated);

@Component({
	selector: "kt-chart-mua-hang",
	templateUrl: "./chart-mua-hang.component.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChartMuaHangComponent implements OnInit {
	private chart: am4charts.XYChart;

	public barChartOptions = {
		responsive: true,
		showAllTooltips: true,
		tooltips: {
			enabled: true,
			mode: "index",
		},
		scales: {
			xAxes: [{}],
			yAxes: [
				{
					id: "y-axis-0",
					position: "left",
					ticks: {
						fontColor: "blue",
						beginAtZero: "zero",
						max: 100,
						stepSize: 5,
					},
					scaleLabel: {
						display: true,
						labelString: "SL mua",
						fontColor: "blue",
					},
				},
				{
					id: "y-axis-1",
					position: "right",
					ticks: {
						fontColor: "red",
						beginAtZero: "zero",
						callback: function (label, index, labels) {
							return new Intl.NumberFormat("de-DE", { style: "decimal", currency: "VND", minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(label));
						},
						stepSize: 5,
					},
					scaleLabel: {
						display: true,
						labelString: "ĐG mua",
						fontColor: "red",
					},
				},
			],
		},
	};
	public barChartType = "bar";
	public barChartLegend = false;
	@Input() barChartLabels: string[] = [];
	@Input() dataLineChart: number[] = [];
	@Input() dataBarChart: number[] = [];
	@Input() labelLineChar: string = "";
	@Input() labelBarChar: string = "";
	@Input() chartId: string = "";

	public barChartData: any[] = [
		{ data: [], label: this.labelLineChar, type: "line", fill: false, yAxisID: "y-axis-1" },
		{ data: [], label: this.labelBarChar, stack: "a" },
	];

	constructor(private changeDetect: ChangeDetectorRef, @Inject(PLATFORM_ID) private platformId, private zone: NgZone) {}

	ngOnInit() {
		this.barChartData[0].data = this.dataLineChart;
		this.barChartData[1].data = this.dataBarChart;
		this.barChartOptions.scales.yAxes[0].ticks.max = Math.max(...this.dataBarChart) * 2;
		this.barChartOptions.scales.yAxes[1].ticks.max = Math.max(...this.dataLineChart) * 2;

		this.barChartOptions.scales.yAxes[0].ticks.stepSize = (Math.max(...this.dataBarChart) * 2) / 5;
		this.barChartOptions.scales.yAxes[1].ticks.stepSize = (Math.max(...this.dataLineChart) * 2) / 5;
		this.chartId = this.chartId || "chart-mua-hang-" + Math.random().toString(36).substring(2, 15);
		this.changeDetect.detectChanges();
	}

	browserOnly(f: () => void) {
		if (isPlatformBrowser(this.platformId)) {
			this.zone.runOutsideAngular(() => {
				f();
			});
		}
	}

	ngAfterViewInit() {
		this.browserOnly(() => {
      var chart = am4core.create(this.chartId, am4charts.XYChart);
      chart.colors.step = 2;
      chart.maskBullets = false;
      chart.data = [];
      this.barChartLabels.forEach((element, index) => {
        chart.data.push({
          value: element + new Array(index + 1).join(" "),
          distance: this.dataBarChart[index],
          duration: this.dataLineChart[index],
        });
      });
      const durations = this.dataLineChart;
      const minDuration = Math.min(...durations);
      const maxDuration = Math.max(...durations);
      const avgDuration =
        durations.reduce((a, b) => a + b, 0) / durations.length;
      const isAllSameDuration = minDuration === maxDuration && maxDuration === avgDuration;
      const formatPrice = (value: number) => this.f_number(value);
      const avgLabelIndex = Math.floor(this.barChartLabels.length / 2);
    
      chart.data.forEach((d, index) => {
        d.isMin = d.duration === minDuration;
        d.isMax = d.duration === maxDuration;
        d.hideMinMax = isAllSameDuration || !(d.isMin || d.isMax);
        d.avgValue = avgDuration;
        d.avgText = "Giá TB: " + formatPrice(avgDuration);
        d.hideAvgLabel = index !== avgLabelIndex;
        if (!isAllSameDuration) {
          if (d.isMax) {
            d.minMaxText = "Giá cao nhất: " + formatPrice(d.duration) + " đ";
            d.minMaxDy = 0;
            d.minMaxDx = -180;
            d.minMaxPointerX = 1;
            d.minMaxPointerY = -1;
            d.minMaxBg = "#C2185B"
            d.minMaxBorder = "#FFFFFF";
            d.minMaxColor = "#FFFFFF";
          } else if (d.isMin) {
            d.minMaxText = "Giá thấp nhất: " + formatPrice(d.duration) + " đ";
            d.minMaxDy = 0;
            d.minMaxDx = 8;
            d.minMaxPointerX = -1;
            d.minMaxPointerY = -1;
            d.minMaxBg = "#1565C0";
            d.minMaxBorder = "#FFFFFF";
            d.minMaxColor = "#FFFFFF";
          }
        }
      });
      var dateAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      dateAxis.dataFields.category = "value";
    
      var distanceAxis = chart.yAxes.push(new am4charts.ValueAxis());
      distanceAxis.title.text = "SL mua";
    
      var durationAxis = chart.yAxes.push(new am4charts.ValueAxis());
      durationAxis.title.text = "ĐG mua";
      durationAxis.renderer.opposite = true;
      durationAxis.syncWithAxis = distanceAxis;
    
      var latitudeAxis = chart.yAxes.push(new am4charts.ValueAxis());
      latitudeAxis.renderer.grid.template.disabled = true;
      latitudeAxis.renderer.labels.template.disabled = true;
      latitudeAxis.syncWithAxis = distanceAxis;
    
      var distanceSeries = chart.series.push(new am4charts.ColumnSeries());
      distanceSeries.dataFields.valueY = "distance";
      distanceSeries.dataFields.categoryX = "value";
      distanceSeries.yAxis = distanceAxis;
      distanceSeries.name = "SL mua";
      distanceSeries.columns.template.fillOpacity = 0.7;
      distanceSeries.tooltipText = "{valueY}";
    
      var durationSeries = chart.series.push(new am4charts.LineSeries());
      durationSeries.dataFields.valueY = "duration";
      durationSeries.dataFields.categoryX = "value";
      durationSeries.yAxis = durationAxis;
      durationSeries.name = "ĐG mua";
      durationSeries.strokeWidth = 2;
      durationSeries.tooltipText = "{valueY}";
      durationSeries.maskBullets = false;
    
      var durationBullet = durationSeries.bullets.push(new am4charts.CircleBullet());
      durationBullet.circle.radius = 4;
      durationBullet.circle.fill = am4core.color("#7B1FA2");
    
      var minMaxBullet = durationSeries.bullets.push(new am4charts.CircleBullet());
      minMaxBullet.circle.radius = 5;
      minMaxBullet.circle.fill = am4core.color("#7B1FA2");
      minMaxBullet.propertyFields.disabled = "hideMinMax";
    
      var minMaxLabel = durationSeries.bullets.push(new am4charts.LabelBullet());
      minMaxLabel.label.text = "{minMaxText}";
      minMaxLabel.label.fontSize = 13;
      minMaxLabel.label.dy = -20;
      minMaxLabel.label.fill = am4core.color("#FFFFFF");
      minMaxLabel.label.fontWeight = "600";
      minMaxLabel.label.fontFamily = "Inter, system-ui, sans-serif";
      minMaxLabel.label.hideOversized = false;
      minMaxLabel.label.truncate = false;
      minMaxLabel.label.wrap = false;
      minMaxLabel.label.horizontalCenter = "left";
      minMaxLabel.label.verticalCenter = "top";
      minMaxLabel.label.propertyFields.fill = "minMaxColor";
      
      const minMaxBackground = new am4core.PointedRectangle();
      minMaxBackground.cornerRadius = 6;
      minMaxBackground.pointerLength = 8;
      minMaxBackground.pointerBaseWidth = 10;
      minMaxLabel.label.background = minMaxBackground;
      minMaxLabel.label.background.fill = am4core.color("#C2185B");
      minMaxLabel.label.background.stroke = am4core.color("#E0E0E0");
      minMaxLabel.label.background.strokeWidth = 2;
      minMaxLabel.label.background.filters.push(new am4core.DropShadowFilter());
      minMaxLabel.label.background.propertyFields.fill = "minMaxBg";
      minMaxLabel.label.background.propertyFields.stroke = "minMaxBorder";
      
      minMaxLabel.label.padding(6, 12, 6, 12);
      minMaxLabel.propertyFields.dy = "minMaxDy";
      minMaxLabel.propertyFields.dx = "minMaxDx";
      minMaxLabel.propertyFields.disabled = "hideMinMax";
    
      var avgSeries = chart.series.push(new am4charts.LineSeries());
      avgSeries.name = "Giá trung bình";
      avgSeries.dataFields.valueY = "avgValue";
      avgSeries.dataFields.categoryX = "value";
      avgSeries.yAxis = durationAxis;
      avgSeries.stroke = am4core.color("#FFC107");
      avgSeries.strokeWidth = 2;
      avgSeries.strokeDasharray = "4,4";
    
      var avgLabel = avgSeries.bullets.push(new am4charts.LabelBullet());
      avgLabel.label.text = "{avgText} đ";
      avgLabel.label.fontSize = 13;
      avgLabel.label.fill = am4core.color("#FFFFFF");
      avgLabel.label.fontWeight = "600";
      avgLabel.label.wrap = false;
      avgLabel.label.truncate = false;
      avgLabel.label.hideOversized = false;
      avgLabel.label.horizontalCenter = "middle";
      avgLabel.label.verticalCenter = "middle";

      avgLabel.label.background = new am4core.RoundedRectangle();
      avgLabel.label.background.fill = am4core.color("#C49000");
      avgLabel.label.background.stroke = am4core.color("#E0E0E0");
      avgLabel.label.background.strokeWidth = 2;
      avgLabel.label.background.filters.push(new am4core.DropShadowFilter());
      (avgLabel.label.background as am4core.RoundedRectangle).cornerRadius(6, 6, 6, 6);

      avgLabel.label.padding(6, 12, 6, 12);
      avgLabel.locationX = 0.5;
      avgLabel.dy = -20;
      avgLabel.propertyFields.disabled = "hideAvgLabel";
    
      chart.legend = new am4charts.Legend();
      chart.cursor = new am4charts.XYCursor();
    
      this.chart = chart;
    });    
	}

	ngOnDestroy() {
		this.browserOnly(() => {
			if (this.chart) {
				this.chart.dispose();
			}
		});
	}

	f_number(item: any = "0.00") {
		return FunctionPublic.F_NUMBER(item);
	}
}
